import { IconStarHalfSolid, IconStarSolid, Space, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CatalogItemRatingStarStyled } from './styles/CatalogItemRatingStarStyled'

const STAR_GLYPH_SIZE = 14
const HALF_STAR_THRESHOLD = 0.25
const FULL_STAR_THRESHOLD = 0.75
const UNEARNED_STAR_COLOR = 'lightGrey'

export interface ICatalogItemRatingProps {
  value: number
  count: number
  scaleMax: number
}

export const CatalogItemRating = ({
  value,
  count,
  scaleMax,
}: ICatalogItemRatingProps) => {
  const intl = useProcurifyIntl()

  const positions = Array.from({ length: scaleMax }, (_, index) => index)

  const earnedStars = positions.map((index) => {
    const remainder = value - index
    if (remainder >= FULL_STAR_THRESHOLD) {
      return <IconStarSolid block size={STAR_GLYPH_SIZE} />
    }
    if (remainder >= HALF_STAR_THRESHOLD) {
      return <IconStarHalfSolid block size={STAR_GLYPH_SIZE} />
    }
    return null
  })

  const ariaLabel = intl.formatMessage(messages.ratingAriaLabel, {
    value,
    scaleMax,
    count,
  })

  return (
    <div role='img' aria-label={ariaLabel}>
      <Space direction='horizontal' size='xsmall' align='center'>
        <SubText bold aria-hidden>
          {intl.formatNumber(value, { maximumFractionDigits: 1 })}
        </SubText>
        <Space direction='horizontal' size='xsmall' align='center'>
          {positions.map((index) => (
            <CatalogItemRatingStarStyled key={index}>
              <IconStarSolid
                block
                size={STAR_GLYPH_SIZE}
                color={UNEARNED_STAR_COLOR}
              />
              {earnedStars[index]}
            </CatalogItemRatingStarStyled>
          ))}
        </Space>
        <SubText color='textSecondary' aria-hidden>
          {intl.formatMessage(messages.reviewCount, { count })}
        </SubText>
      </Space>
    </div>
  )
}
